export default "__VITE_ASSET__InUySBdW__"